import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { doSafe } from 'shared/promise';
import { uri } from 'shared/uri';
export function useWindowInfo() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [info, setInfo] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (typeof window !== "undefined") {
        const handleUpdate = () => setInfo(_temp);
        handleUpdate();
        const observer = new MutationObserver(handleUpdate);
        observer.observe(document.querySelector("title"), {
          childList: true
        });
        window.addEventListener("popstate", handleUpdate);
        return () => {
          observer.disconnect();
          window.removeEventListener("popstate", handleUpdate);
        };
      }
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== info.url) {
    t3 = doSafe(info.url, uri);
    $[3] = info.url;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== info.title || $[6] !== t3) {
    t4 = {
      url: t3,
      title: info.title
    };
    $[5] = info.title;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp(p) {
  const url = window.location.href;
  const title = document.title;
  return p.url == url && p.title == title ? p : {
    url,
    title
  };
}